import { NgModule } from '@angular/core';
import { AuthenticatedRoutingModule } from './authenticated-routing.module';
import { AuthenticatedComponent } from './authenticated.component';
import { SharedModule } from '../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { SideNavComponent } from './components/side-nav/side-nav.component';
import { TopNavComponent } from './components/top-nav/top-nav.component';
import { AccountInfoComponent } from './components/account-info/account-info.component';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';

@NgModule({
  imports: [
    AuthenticatedRoutingModule, 
    SharedModule,
    CommonModule
  ],
  declarations: [
    AuthenticatedComponent,
    SideNavComponent,
    TopNavComponent,
    AccountInfoComponent,
    ConfirmationDialogComponent
  ]
})
export class AuthenticatedModule {}
